import { ReactNode } from 'react'

export enum PlanFeatureLabel {
  CONTAINS = 'Contém',
  NOT_CONTAINS = 'Não contém',
}

export interface PlanFeature {
  contains: boolean
  label: PlanFeatureLabel
  className?: string
}

export interface Benefit {
  description: string
  planFeatures: [PlanFeature, PlanFeature, PlanFeature]
  popoverDescription?: string
  icon?: ReactNode
}

export interface Plan {
  label: string
  className?: string
}

export interface TableData {
  plans: Plan[]
  benefits: Benefit[]
}

export type CreateFeatureProps = {
  hasFeature: boolean
  className?: string
}

export type GetFeaturesProps = {
  addBasic: boolean
  addAdvanced: boolean
  addJusAI: boolean
  jusAIClass?: string
}
